import React from 'react'
import ServiceLayout from 'components/ServiceLayout'

const BLOCKS = [
  {
    title: 'Naming & Posicionamento',
    desc: 'O nome e o lugar que sua marca ocupa na cabeça do público.',
    items: [
      'Diagnóstico de posicionamento atual',
      'Estudo de mercado e concorrência',
      'Naming e arquitetura de marca',
      'Definição de proposta de valor',
    ],
  },
  {
    title: 'Estratégia de Marca',
    desc: 'A base que vai guiar cada decisão de comunicação nos próximos anos.',
    items: [
      'Personalidade e arquétipo de marca',
      'Tom de voz e identidade verbal',
      'Missão, visão e valores',
      'Criação de Persona',
    ],
  },
  {
    title: 'Identidade Visual',
    desc: 'A experiência visual completa em cada ponto de contato com o público.',
    items: [
      'Logotipo e sistema de marca',
      'Paleta de cores e tipografia',
      'Aplicações online e offline',
      'Manual de marca',
    ],
  },
]

const STEPS = [
  { title: 'Diagnóstico', desc: 'Entendemos seu negócio, seu público e o que a marca representa hoje.' },
  { title: 'Estratégia', desc: 'Definimos posicionamento, narrativa e personalidade de marca.' },
  { title: 'Criação', desc: 'Damos forma visual e verbal ao que foi estrategicamente definido.' },
  { title: 'Entrega', desc: 'Manual de marca completo e assessoria na implementação.' },
]

function ServiceBranding() {
  return (
    <ServiceLayout
      pageTitle='Agência Dorac - Branding & Identidade Visual'
      eyebrow='Branding & Identidade Visual'
      title='Marcas que são sentidas antes de serem vistas'
      subtitle='Construímos identidades que capturam a essência da sua marca e criam valor percebido, de forma humanizada e estratégica.'
      intro='Não fazemos apenas logotipos. Antes de qualquer traço, mergulhamos no diagnóstico de comportamento do seu público para entender o que precisa ser dito, sentido e reconhecido. O resultado é uma marca coerente do posicionamento à última aplicação visual.'
      blocks={BLOCKS}
      steps={STEPS}
      ctaText='Quero uma marca forte'
    />
  )
}

export default ServiceBranding
